import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 0;
  max-width: 800px;
  margin: 0 auto;
  background-color: #f8f9fa;
  min-height: 100%;
  overflow-y: auto;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  right: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  background-color: #2e5cb8;
  color: white;
  padding: 15px 20px;
`;

export const PageTitle = styled.h1`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: white;
`;

export const ContentSection = styled.div`
  margin-top: 0;
  padding: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  padding-bottom: 40px; /* Add extra padding at bottom for better scroll experience */
`;

export const ThankYouText = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
`;

export const OfficeInfo = styled.div`
  margin-top: 10px;
  color: #555;
  text-align: center;
  
  div:first-child {
    font-weight: 500;
  }
`;

export const Description = styled.p`
  margin-top: 15px;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
`;

export const RatingGroup = styled.div`
  margin-top: 25px;
  padding: 15px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

export const RatingTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
  color: #1976d2;
`;

export const RatingTitleText = styled.div`
  font-weight: 600;
  font-size: 16px;
`;

export const RatingSubtitle = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
`;

export const StarsContainer = styled.div`
  margin-top: 12px;
  display: flex;
`;

interface StarProps {
  filled?: boolean;
}

export const Star = styled.span<StarProps>`
  font-size: 30px;
  color: ${props => props.filled ? 'gold' : '#ccc'};
  cursor: pointer;
  margin-right: 8px;
  transition: transform 0.1s ease;
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  
  &:hover {
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const FeedbackInput = styled.textarea`
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 80px;
  font-family: inherit;
  
  &:focus {
    outline: none;
    border-color: #1976d2;
  }
`;

export const FutureCollabContainer = styled.div`
  margin-top: 30px;
  padding: 15px;
  border-radius: 8px;
  background-color: #f0f7ff;
`;

export const FutureCollabTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const EmojiContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
`;

interface EmojiOptionProps {
  selected?: boolean;
}

export const EmojiOption = styled.div<EmojiOptionProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32%;
  padding: 10px;
  background-color: ${props => props.selected ? '#e6f7ff' : 'white'};
  border: 1px solid ${props => props.selected ? '#1976d2' : '#ddd'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 80px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  
  &:hover {
    background-color: ${props => props.selected ? '#e6f7ff' : '#f5f5f5'};
  }
  
  &:active {
    transform: scale(0.98);
    background-color: ${props => props.selected ? '#d6edff' : '#eeeeee'};
  }
`;

export const Emoji = styled.span`
  font-size: 24px;
  margin-bottom: 8px;
  margin-right: 0;
`;

export const CollabIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const EmojiLabel = styled.span`
  font-size: 12px;
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background-color: ${props => props.disabled ? '#ccc' : '#2e5cb8'};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s ease;
  min-height: 48px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  
  &:hover {
    background-color: ${props => props.disabled ? '#ccc' : '#1565c0'};
  }
  
  &:active {
    background-color: ${props => props.disabled ? '#ccc' : '#0d47a1'};
  }
`;

export const SecondaryButton = styled.button`
  padding: 12px 16px;
  background-color: transparent;
  border: none;
  color: #2e5cb8;
  font-size: 14px;
  font-weight: normal;
  margin-top: 15px;
  cursor: pointer;
  min-height: 44px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  
  &:hover {
    text-decoration: underline;
  }
  
  &:active {
    opacity: 0.7;
  }
`;

export const BlockWarningMessage = styled.div`
  background-color: #fff5f5;
  border-radius: 6px;
  padding: 8px 12px;
  margin-top: 10px;
  color: #FB7672;
  font-size: 14px;
  line-height: 1.5;
`;

export const OverallRatingSection = styled.div`
  padding: 20px;
  background-color: white;
  margin-bottom: 0;
`;

export const OverallRatingTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #333;
`;

export const ShiftDateText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
`;

export const OverallStarRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin: 12px 0 4px;
`;

interface OverallStarBtnProps {
  $active: boolean;
}

export const OverallStarButton = styled.div<OverallStarBtnProps>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  border-radius: 8px;
  border: 2px solid ${({ $active }) => ($active ? '#f5a623' : '#e0e0e0')};
  background-color: ${({ $active }) => ($active ? '#fff8e1' : '#fff')};
  cursor: pointer;
  transition: all 0.15s;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  &:hover {
    border-color: #f5a623;
  }
`;

export const OverallStarIcon = styled.span<OverallStarBtnProps>`
  font-size: 1.8rem;
  color: ${({ $active }) => ($active ? '#f5a623' : '#ccc')};
  transition: color 0.15s;
`;

export const LabelsRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LabelText = styled.span`
  font-size: 12px;
  color: #999;
`;

export const Divider = styled.div`
  border-top: 2px dashed #e0e0e0;
  margin: 16px 0;
`;

export const ValidationError = styled.div`
  color: #FB7672;
  font-size: 13px;
  margin-top: 6px;
`;

export const SectionLabel = styled.h3`
  font-weight: 600;
  font-size: 16px;
  margin: 0 0 8px 0;
  color: #333;
`;